
import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css


import Vue from 'vue'
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast'

Vue.use(ToastService, Toast);